import defaultAvatar from '@/assets/default-avatar.png';

export const DEFAULT_AVATAR = defaultAvatar;
export const DEFAULT_LOGO = 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAwIiBoZWlnaHQ9IjEwMCIgdmlld0JveD0iMCAwIDIwMCAxMDAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgPHJlY3Qgd2lkdGg9IjIwMCIgaGVpZ2h0PSIxMDAiIGZpbGw9IiNFMEUwRTAiLz4KICA8dGV4dCB4PSIxMDAiIHk9IjUwIiBmb250LWZhbWlseT0iQXJpYWwiIGZvbnQtc2l6ZT0iMTQiIGZpbGw9IiM5OTkiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGFsaWdubWVudC1iYXNlbGluZT0ibWlkZGxlIj5Db21wYW55IExvZ288L3RleHQ+Cjwvc3ZnPg==';

export const validatePhotoUrl = async (url) => {
    if (!url) return null;
    if (url === DEFAULT_AVATAR) return url;
    if (url === DEFAULT_LOGO) return url;

    // Skip validation for known good URLs
    if (url.includes('firebasestorage.googleapis.com') || 
        url.includes('googleusercontent.com')) {
        return url;
    }

    try {
        // Test if the URL is accessible
        const response = await fetch(url, { method: 'HEAD' });
        return response.ok ? url : null;
    } catch (error) {
        console.error('Error validating photo URL:', error);
        return null;
    }
}; 